import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import getTheme from "./Theme"
import { MantineProvider } from "@mantine/core";
import { manTheme } from "./MantineTheme";
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode> 
    <MantineProvider theme={manTheme}>
    <ThemeProvider theme={getTheme}>
      <CssBaseline /> {/* ensures consistent baseline styles */}
      {/* your routes/components */}
      <App />
    </ThemeProvider>  
    </MantineProvider>
    
    <ToastContainer/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
